import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
// @ts-ignore
import { Button, ButtonWithIcon } from '@els/els-react--button';
import { useDispatch } from 'react-redux';
import { isPOCRedirectValid, loginFlow } from '../login/login-thunk';

const Welcome = () => {
    const dispatch = useDispatch();
    const { ecrId } = useParams<{ ecrId: string }>();

    useEffect(() => {
        if (ecrId) {
            dispatch(isPOCRedirectValid({ ecrId }));
        }
    }, [ecrId, dispatch]);

    const login = () => {
        dispatch(loginFlow());
    };

    return (
        <div className="welcome-background">
            <div className="welcome-box">
                <h3>Welcome To Clinical Learning Hub!</h3>
                <h4>
                    Our goal at Elsevier is to provide you with an optimal
                    learning & development experience.
                </h4>
                <h4>
                    Clinical Learning Hub users, please click below to reach the
                    login page.
                </h4>

                <ButtonWithIcon
                    sprite="ChevronRight"
                    onClick={login}
                    iconRight
                    size="default"
                    className="u-els-float-right sign-in-desktop"
                    aria-label="Sign in (desktop view)"
                >
                    Sign in
                </ButtonWithIcon>
                <Button
                    onClick={login}
                    expanded
                    className="sign-in-mobile"
                    aria-label="Sign in (mobile view)"
                >
                    Sign in
                </Button>
            </div>
        </div>
    );
};

export default Welcome;
